import type {LocaleDateTimeFormat} from 'platform/locale';

import {isNil} from 'ramda';

const TIME_RANGE_SEPARATOR = ' – ';

type DateTimeFormatter = (dateTimeFormat: LocaleDateTimeFormat, value: Date) => string;

export const formatTestDriveTimeRange = (
  start: Date,
  end: Date | null,
  formatDateTime: DateTimeFormatter
) => {
  const formattedStart = formatDateTime('timeShort', start);

  return isNil(end)
    ? formattedStart
    : `${formattedStart}${TIME_RANGE_SEPARATOR}${formatDateTime('timeShort', end)}`;
};
